import {withTranslation} from '@wix/yoshi-flow-editor'
import {getTickets, getTicketsPdf} from '../../../selectors/placed-order'
import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {TicketsDownloadRuntimeProps} from './interfaces'
import {TicketsDownload as Presentation} from './tickets-download'

const mapRuntime = ({
  state,
  actions: {downloadTickets, getOrder},
  staticsBaseUrl,
}: DetailsPageAppProps): TicketsDownloadRuntimeProps => ({
  staticsBaseUrl,
  event: state.event,
  orderNumber: state.placedOrder.order.orderNumber,
  tickets: getTickets(state),
  ticketsPdf: getTicketsPdf(state),
  downloadTickets,
  getOrder,
})

export const TicketsDownload = connect<{}, TicketsDownloadRuntimeProps>(mapRuntime)(withTranslation()(Presentation))
